import React, { useState } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import AddBtn from 'components/AddBtn';
import FormToAddImg from './FormToAddImg';
import { ImageInCarrosselScreens } from 'types/ImageInCarrosselScreens';

type CreateImgWithRedirectAndLabelProps = {
	imgs: ImageInCarrosselScreens[];
	// eslint-disable-next-line no-unused-vars
	getImgs: (_imgs: ImageInCarrosselScreens[]) => void;
	textBtn?: string;
};

export default function CreateImgWithRedirectAndLabel({
	imgs,
	getImgs,
	textBtn = 'Adicionar imagem'
}: CreateImgWithRedirectAndLabelProps) {
	const [isOpenForm, setIsOpenForm] = useState(false);
	const [imgToEdit, setImgToEdit] = useState<null | ImageInCarrosselScreens>(
		null
	);

	function resetForm() {
		setIsOpenForm(false);
		setImgToEdit(null);
	}

	function deleteImg(img: ImageInCarrosselScreens) {
		const newImgsArray = imgs.filter((value) => value.id !== img.id);
		getImgs(newImgsArray);
	}

	function addImg(img: ImageInCarrosselScreens) {
		const newImgsArray = [...imgs, img];
		getImgs(newImgsArray);
	}

	function editImg(img: ImageInCarrosselScreens) {
		const newImgsArray = imgs.map((value) => {
			if (value.id === img.id) {
				return img;
			}

			return value;
		});
		getImgs(newImgsArray);
	}

	return (
		<S.container>
			<AddBtn
				text={textBtn}
				anyFunction={() => {
					setIsOpenForm(true);
				}}
			/>

			{imgs.length > 0 ? (
				<S.listImgs>
					{imgs.map((img) => (
						<S.imgOption key={img.id}>
							<img src={img.urlImage} alt={img.labelImage || ''} />
							<S.infos>
								{img.linkRedirect && img.linkRedirect !== '' && (
									<p>
										<b>Redirect:</b>
										{img.linkRedirect}
									</p>
								)}
								{img.labelImage && img.labelImage !== '' && (
									<p>
										<b>Texto:</b>
										{img.labelImage}
									</p>
								)}
							</S.infos>

							<S.actions>
								<MdDelete
									onClick={() => {
										deleteImg(img);
									}}
								/>
								<MdEdit
									onClick={() => {
										setIsOpenForm(true);
										setImgToEdit(img);
									}}
								/>
							</S.actions>
						</S.imgOption>
					))}
				</S.listImgs>
			) : (
				<S.listImgsEmpty>
					<p>Não há imagens cadastradas</p>
				</S.listImgsEmpty>
			)}

			{isOpenForm && (
				<FormToAddImg
					excFunctionWhenClicksOnSaveBtn={imgToEdit === null ? addImg : editImg}
					imgToEdit={imgToEdit}
					isOpenForm={isOpenForm}
					resetForm={resetForm}
				/>
			)}
		</S.container>
	);
}
